import { isEmpty, reject } from 'ramda';

const env = process.env.NEXT_PUBLIC_PROJECT_ENV;

let baseUrl = process.env.NEXT_PUBLIC_URL ?? '';
const vercelUrl = process.env.NEXT_PUBLIC_VERCEL_URL;
if (env === 'preview' && !baseUrl && vercelUrl) {
  baseUrl = `https://${vercelUrl}`;
}

export default {
  abTasty: { scriptSrc: process.env.AB_TASTY_SCRIPT_SRC as string },
  baseUrl,
  bugsnag: { apiKey: process.env.NEXT_PUBLIC_BUGSNAG_API_KEY as string },
  cookiebot: {
    domainGroupId: process.env.NEXT_PUBLIC_COOKIEBOT_DOMAIN_GROUP_ID as string,
  },
  datocms: {
    fullAccessToken: process.env.DATOCMS_FULL_ACCESS_TOKEN as string,
    readToken: process.env.NEXT_PUBLIC_DATOCMS_READ_TOKEN as string,
    previewSecret: process.env.DATOCMS_PREVIEW_SECRET as string,
    environment: process.env.NEXT_PUBLIC_DATOCMS_ENVIRONMENT as string,
    webhookSecret: process.env.DATOCMS_WEBHOOK_SECRET,
  },
  env,
  gaconnector: {
    accountId: process.env.NEXT_PUBLIC_GACONNECTOR_ACCOUNT_ID,
  },
  google: {
    clientId:
      '676500801588-v1fpojke5mvknngkf33c3ajcafle6kdq.apps.googleusercontent.com',
  },
  gtm: {
    id: 'GTM-P26TMM',
    serverUrl: 'https://sgtm.ironhack.com',
    environment: reject(isEmpty, {
      gtmAuth: '',
      gtmPreview: '',
    }),
  },
  ironhack: {
    emailValidator: {
      apiKey: process.env.IH_EMAIL_VALIDATOR_API_KEY as string,
      baseUrl: process.env.IH_EMAIL_VALIDATOR_BASE_URL as string,
    },
    preStudentPortal: {
      baseUrl: process.env.PRE_STUDENT_PORTAL_HOST as string,
      sessionSecret: process.env.PRE_STUDENT_PORTAL_SESSION_SECRET as string,
    },
    userService: {
      apiKey: process.env.USER_SERVICE_API_KEY as string,
      baseUrl: process.env.USER_SERVICE_HOST as string,
    },
  },
  keycloak: {
    host: 'https://account.ironhack.com',
    clientId: 'website',
    clientSecret: process.env.KEYCLOAK_CLIENT_SECRET,
  },
  salesforce: {
    baseUrl: process.env.SALESFORCE_HOST as string,
    campaignId: process.env.NEXT_PUBLIC_SALESFORCE_CAMPAIGN_ID as string,
    clientId: process.env.SALESFORCE_CLIENT_ID as string,
    clientSecret: process.env.SALESFORCE_CLIENT_SECRET as string,
    refreshToken: process.env.SALESFORCE_REFRESH_TOKEN as string,
  },
  turnstile: {
    secretKey: process.env.TURNSTILE_SECRET_KEY as string,
    siteKey: process.env.NEXT_PUBLIC_TURNSTILE_SITE_KEY as string,
  },
  vercel: {
    apiToken: process.env.VERCEL_API_TOKEN as string,
    edgeConfigEndpoint: process.env.VERCEL_EDGE_CONFIG_ENDPOINT as string,
  },
  websiteApiTokenSecret: process.env.WEBSITE_API_TOKEN_SECRET as string,
};
